import { getAIMovieRecommendations, getSurpriseMovieRecommendation } from './openaiService';

// Mock film veritabanı (arama için hala kullanılıyor)
const MOCK_MOVIES = [
    { id: 1, title: "Esaretin Bedeli", genre: "Drama", year: 1994, rating: 9.3, description: "İki hükümlü yıllar boyunca dostluk kurar ve sonunda yaşanan küçük iyiliklerde teselli ve nihayetinde özgürlük bulur." },
    { id: 2, title: "Baba", genre: "Suç", year: 1972, rating: 9.2, description: "Yaşlanan patriyark Don Vito Corleone'nin suç imparatorluğunun kontrolünü isteksiz oğlu Michael'a devretmesi." },
    { id: 3, title: "Kara Şövalye", genre: "Aksiyon", year: 2008, rating: 9.0, description: "Joker, Gotham'ı kaosa sürüklerken Batman en büyük psikolojik ve fiziksel testlerinden birini kabul eder." },
    { id: 4, title: "Ucuz Roman", genre: "Suç", year: 1994, rating: 8.9, description: "Los Angeles'ta birbirine bağlı suçlu, dalgın ve kötü şöhretli karakterlerin hikayesi." },
    { id: 5, title: "Forrest Gump", genre: "Drama", year: 1994, rating: 8.8, description: "Alabama'lı bir adamın başkalarına yardım ederken kendi hayatını yaşadığı birkaç on yılın kronikleri." },
    { id: 6, title: "Başlangıç", genre: "Bilim Kurgu", year: 2010, rating: 8.8, description: "Rüya paylaşım teknolojisi aracılığıyla kurumsal sırları çalan bir hırsız." },
    { id: 7, title: "Matrix", genre: "Bilim Kurgu", year: 1999, rating: 8.7, description: "Bilgisayar programcısı Neo, gerçeklik ve rüya arasındaki sınırları sorgular." },
    { id: 8, title: "İyi Adamlar", genre: "Suç", year: 1990, rating: 8.7, description: "Henry Hill ve arkadaşlarının mafyadaki yaşamı 1955'ten 1980'e kadar." },
    { id: 9, title: "Yıldızlararası", genre: "Bilim Kurgu", year: 2014, rating: 8.6, description: "Dünya'nın ölmekte olduğu yakın gelecekte, eski NASA pilotu Cooper'ın insanlığı kurtarmak için görevde." },
    { id: 10, title: "Parazit", genre: "Gerilim", year: 2019, rating: 8.6, description: "Yoksul bir ailenin zengin bir ailenin hayatına sızması." },
    { id: 11, title: "Yenilmezler: Son Oyun", genre: "Aksiyon", year: 2019, rating: 8.4, description: "Infinity War'daki olaylardan sonra, evren Thanos'un eylemlerinin ardından harap durumda." },
    { id: 12, title: "Aşk Diyarı", genre: "Romantik", year: 2016, rating: 8.0, description: "Los Angeles'ta aşık olan müzisyen Sebastian ve oyuncu Mia'nın hikayesi." },
    { id: 13, title: "Büyük Budapeşte Oteli", genre: "Komedi", year: 2014, rating: 8.1, description: "Ünlü Avrupa otelinin concierge'i ve protégé'sinin maceraları." },
    { id: 14, title: "Çılgın Max: Öfke Yolu", genre: "Aksiyon", year: 2015, rating: 8.1, description: "Çorak bir gelecekte, Max ve Furiosa'nın bir tiranın elinden kaçma mücadelesi." },
    { id: 15, title: "Aşk", genre: "Romantik", year: 2013, rating: 8.0, description: "Yakın gelecekte, bir yazarın yapay zeka işletim sistemiyle olan ilişkisi." }
];

const GENRES = [
    "Aksiyon", "Komedi", "Drama", "Korku", "Romantik", "Bilim Kurgu", "Gerilim", "Suç", "Macera", "Fantastik", "Animasyon", "Aile"
];

// Film arama fonksiyonu (mock verilerle)
export const searchMovies = async (query) => {
    return MOCK_MOVIES.filter(movie =>
        movie.title.toLowerCase().includes(query.toLowerCase()) ||
        movie.genre.toLowerCase().includes(query.toLowerCase())
    );
};

// ⭐ GERÇEK ChatGPT API ile film öneri alma fonksiyonu
export const getMovieRecommendations = async (userPreferences, excludeCurrentTitles = [], excludeCurrentTmdbIds = []) => {
    try {
        // User ID'yi ekle
        const enhancedPreferences = {
            ...userPreferences,
            userId: userPreferences.userId || null
        };
        
        // Gerçek ChatGPT API çağrısı
        const result = await getAIMovieRecommendations(enhancedPreferences, excludeCurrentTitles, excludeCurrentTmdbIds);
        return result;

    } catch (error) {
        console.error('❌ ChatGPT API Hatası:', error);
        // Hata durumunda fallback mock sistem
        return await getMockRecommendations(userPreferences);
    }
};

// Fallback mock sistem (API hatası durumunda)
const getMockRecommendations = async (userPreferences) => {
    const { genres, favoriteMovies } = userPreferences;

    // Mock gecikme
    await new Promise(resolve => setTimeout(resolve, 1000));

    let recommendations = [...MOCK_MOVIES];

    // Tür filtresi
    if (genres && genres.length > 0) {
        recommendations = recommendations.filter(movie =>
            genres.includes(movie.genre)
        );
    }

    // Favori filmlere benzer öneriler
    if (favoriteMovies && favoriteMovies.length > 0) {
        const favoriteGenres = favoriteMovies.map(movie => movie.genre);
        recommendations = recommendations.filter(movie =>
            favoriteGenres.includes(movie.genre)
        );
    }

    // Rastgele sırala ve 5 öneri al
    recommendations = recommendations
        .sort(() => 0.5 - Math.random())
        .slice(0, 5)
        .map((movie, index) => ({
            ...movie,
            // Benzersiz ID oluştur mock filmler için de
            id: `mock_${Date.now()}_${index}_${movie.title.toLowerCase().replace(/[^a-z0-9]/g, '').substring(0, 10)}`
        }));

    return {
        recommendations,
        explanation: `⚠️ ChatGPT API kullanılamadığı için mock öneriler gösteriliyor. ${genres?.join(', ') || 'Çeşitli türlerden'} filmler önerdik.`,
        generatedAt: new Date().toISOString()
    };
};

// Tüm türleri getir
export const getGenres = () => {
    return GENRES;
};

// Popüler filmleri getir
export const getPopularMovies = () => {
    return MOCK_MOVIES.slice(0, 10);
};

// Film detayını getir
export const getMovieDetails = (movieId) => {
    return MOCK_MOVIES.find(movie => movie.id === movieId);
};

// ⭐ Sürpriz film/dizi önerisi alma fonksiyonu
export const getSurpriseMovie = async (contentType = 'film', origin = null, previousTitles = []) => {
    try {
        // Gerçek ChatGPT API çağrısı
        const result = await getSurpriseMovieRecommendation(contentType, origin, previousTitles);
        return result;

    } catch (error) {
        console.error('❌ Sürpriz film API Hatası:', error);
        // Hata durumunda fallback mock sistem
        return getMockSurpriseMovie();
    }
};

// Fallback mock sürpriz film (API hatası durumunda)
const getMockSurpriseMovie = () => {
    const randomMovies = [...MOCK_MOVIES];
    const randomMovie = randomMovies[Math.floor(Math.random() * randomMovies.length)];

    return {
        ...randomMovie,
        // Benzersiz ID oluştur mock sürpriz filmler için de
        id: `mock_surprise_${Date.now()}_${randomMovie.title.toLowerCase().replace(/[^a-z0-9]/g, '').substring(0, 10)}`,
        surprise_explanation: `⚠️ ChatGPT API kullanılamadığı için mock önerileri gösteriliyor. ${randomMovie.title} rastgele seçildi ve bugün için harika bir tercih olabilir!`,
        plot: `Bugün ${randomMovie.title} izlemek için mükemmel bir gün! ${randomMovie.description}`
    };
}; 